module.exports = __webpack_public_path__ + "components/flag/static/square/kw-a1f4637587ac7996b0f9e2cb5e0678b2.svg";